import { Grid, Button, TextField } from "@mui/material";
import {useTranslation} from "react-i18next";
import {useState, useEffect, useContext} from "react";
import {Stack} from "@mui/material";
import { ApiContext } from "../../../App";


// Note that we only update a few fields of the facility model in this component
const DEFAULT_FACILITY_DATA = {name: "", lat: "", lon: ""};

const FacilityForm = ({ facility}) => {
    const { t } = useTranslation();
    const [errorMessages, setErrorMessages] = useState({});
    
    const [facilityData, setFacilityData] = useState(DEFAULT_FACILITY_DATA);

    const {facilityApi} = useContext(ApiContext)

    useEffect(() => {
        facilityApi.retrieve(
            facility,
            data => {
                setFacilityData({
                    name: data.name,
                    lat: data.lat,
                    lon: data.lon
                });
            },
            () => {
                alert(t("Couldn't connect to server."));
            }
        )
    },[facility])


    const handleUpdate = () => {

        facilityApi.updatePartial(
            facility,
            facilityData,
            () => {
                setErrorMessages({});
                alert(t("Updated correctly."))
            }, (errors) => {
                setErrorMessages(errors);
                alert(t("Couldn't update settings."))
            }
        )
    }

    return (
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                    display='inline'
                    label={t("Name")}
                    variant="standard"
                    id={"name"}
                    type="string"
                    value={ facilityData.name }
                    onChange={(event) => setFacilityData({...facilityData, name: event.target.value})}
                    error={errorMessages.hasOwnProperty("name")}
                    helperText={errorMessages["name"]? errorMessages["name"]: ""}
                />
                <TextField
                    label={t("Latitude")}
                    variant="standard"
                    id={"lat"}
                    type="number"
                    value={ facilityData.lat }
                    onChange={(event) => setFacilityData({...facilityData, lat: event.target.value})}
                    error={errorMessages.hasOwnProperty("lat")}
                    helperText={errorMessages["lat"]? errorMessages["lat"]: ""}
                />
                <TextField
                    label={t("Longitude")}
                    variant="standard"
                    id={"lon"}
                    type="number"
                    value={ facilityData.lon }
                    onChange={(event) => setFacilityData({...facilityData, lon: event.target.value})}
                    error={errorMessages.hasOwnProperty("lon")}
                    helperText={errorMessages["lon"]? errorMessages["lon"]: ""}
                />
                <Button variant='contained' onClick={handleUpdate}>
                    {t("Update")}
                </Button>
            </Stack>
     );
}
 
export default FacilityForm;